import React from 'react';
import PropTypes from 'prop-types';
import './SignatureParam.css'
import Markdown from './Markdown';

const SignatureParam = ({ param }) => (
    <div className="signature-param">
        <div>
            <span className="signature-param-name">{param.name}</span>
            {param.types.map(type => (
                <span key={type.name} className="signature-param-type">
                    {type.url ?
                        (<a href={`../api-help/${type.url}`}>{type.name}</a>)
                        :
                        (type.name)
                    }
                </span>
            ))}
        </div>

        <div className="signature-arg-description">
            <Markdown text={param.description} />
        </div>
    </div>
);

SignatureParam.propTypes = {
    param: PropTypes.object.isRequired
};

export default SignatureParam;



// WEBPACK FOOTER //
// ./src/SignatureParam.js